import { useTranslation } from 'react-i18next';

import type { InvitationStatus } from '~/api/invitations/types';
import type { IconName } from '~/components/Icon/Icon';
import type { statusColorThemes } from '~/styles/themes.css';

import { StatusTag } from '~/components';

type StatusEntry = {
  icon: IconName;
  status: keyof typeof statusColorThemes;
};

const statusMap: Record<InvitationStatus, StatusEntry> = {
  pending: { icon: 'HourglassTop', status: 'warning' },
  accepted: { icon: 'Check', status: 'success' },
  declined: { icon: 'CloseSmall', status: 'danger' },
};

type Props = {
  status: InvitationStatus;
};

export const InvitationStatusTag = ({ status }: Props) => {
  const { icon, status: statusTheme } = statusMap[status];
  const { t } = useTranslation(['invitations']);

  return <StatusTag icon={icon} label={t(`invitations:sentInvitations.status.${status}`)} status={statusTheme} />;
};
